import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

function Image(props) {
  const [mainSrc, setMainSrc] = useState('');
  const [errored, setErrored] = useState(false);
  const {
    src, fallbackSrc, className, mobileSrc,
  } = props;

  useEffect(() => {
    setMainSrc(src);
  });

  function onError() {
    if (!errored) {
      setMainSrc(fallbackSrc);
      setErrored(true);
    }
  }

  function renderMobileSource() {
    if (mobileSrc && !errored) {
      return `${mobileSrc}`;
    }
    return mainSrc;
  }

  return (
    <picture>
      <source media="(max-width: 600px)" srcSet={renderMobileSource()} />
      <img
        src={mainSrc}
        onError={onError}
        alt="content"
        className={className}
      />
    </picture>
  );
}


Image.propTypes = {
  src: PropTypes.string.isRequired,
  fallbackSrc: PropTypes.string,
  className: PropTypes.string,
  mobileSrc: PropTypes.string,
};

Image.defaultProps = {
  fallbackSrc: '',
  className: '',
  mobileSrc: ''
};

export default Image;
